import lang from "@/views/modules/MultiBranchs/language/en";

let searchFieldsDef = {
    'name': {
        label: lang.LBL_NAME,
    },
    'status': {
        label: lang.LBL_STATUS,
    },
};
export default { searchFieldsDef }